<div class="modal-header">
    <h4 class="modal-title">Your air conditioning estimate</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
    <ngb-alert [dismissible]="false" type="light"
        >To view your prices and products, please fill in the form below.</ngb-alert
    >

    <form [formGroup]="form">
        <div class="row g-2">
            <div class="col-12">
                <sf-floating-label-input
                    [autofocus]="true"
                    label="First Name"
                    inputId="firstName"
                    formControlName="firstName"></sf-floating-label-input>
            </div>
            <div class="col-12">
                <sf-floating-label-input
                    label="Last Name"
                    inputId="lastName"
                    formControlName="lastName"></sf-floating-label-input>
            </div>
            <div class="col-12">
                <sf-floating-label-postcode-input
                    label="Postcode"
                    inputId="postcode"
                    formControlName="postcode"></sf-floating-label-postcode-input>
                <p class="small mb-0">We use this to confirm we cover your area</p>
            </div>
            <div class="col-12">
                <sf-floating-label-input
                    label="Email"
                    inputId="emailAddress"
                    formControlName="emailAddress"></sf-floating-label-input>
            </div>
            <div class="col-12">
                <sf-floating-label-input
                    label="Phone Number"
                    inputId="phone"
                    formControlName="phone"></sf-floating-label-input>
                <p class="small mb-0">We use this to text your quote</p>
            </div>
        </div>

        @if (error()) {
            <ngb-alert type="danger">{{ error() }}</ngb-alert>
        }

        <ngb-alert class="mt-3" type="light" [dismissible]="false">
            <p>
                By continuing, you must consent to your personal data entered above being used for the purpose of
                contacting you to arrange a free home survey visit.
            </p>
            <p>
                We use <a href="https://www.surefiresoftware.co.uk" target="_blank">www.surefiresoftware.co.uk</a> for
                our Quote Engine and their Privacy Policy explains how they collect and store your personal data.
            </p>

            <sf-toggle
                class="mt-3"
                activeText="Yes I consent"
                inactiveText="Yes I consent"
                inputId="confirmed"
                formControlName="confirmed"></sf-toggle>
        </ngb-alert>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="activeModal.close('Close click')">Cancel</button>
    <button type="button" class="btn btn-success" [disabled]="form.invalid" (click)="submit()">Submit</button>
</div>
